import { compSetQueryOptions } from '@quoruum/frontend-common/oas/gen/quoruum/@tanstack/react-query.gen';
import { defineEntitySchema } from './base/EntitySchema';
import { hotelSchema } from './hotel';

// Comp sets belong to a hotel: pick a hotel, then pick one of its comp sets.
export const compSetSchema = defineEntitySchema({
  name: 'compSet',
  label: 'Comp Set',
  endpoints: {
    query: compSetQueryOptions,
    orgIdFilter: (organizationId, request) => ({
      ...request,
      query: { ...request.query, organizationId },
    }),
  },
  // After `endpoints`, so the entity type is inferred from `query` first.
  selector: {
    entity: hotelSchema,
    setParentId: (hotelId) => ({ query: { parentIds: [hotelId] } }),
    getId: (compSet) => compSet.parent?.id,
  },
  primaryText: (compSet) => compSet.parent?.name || '',
  fields: [
    { key: 'parent.name', label: 'Hotel', type: 'string', readOnly: true },
    { key: 'label', label: 'Label', type: 'string', readOnly: true },
    {
      key: 'type',
      label: 'Type',
      type: 'enum',
      options: ['MANUAL', 'GEO_INFERRED'],
      readOnly: true,
    },
    {
      key: 'sites',
      label: 'Sites',
      type: 'string',
      readOnly: true,
      display: (compSet) => compSet.sites?.join(', ') ?? '',
    },
    {
      key: 'children',
      label: 'Competitors',
      type: 'string',
      readOnly: true,
      display: (compSet) => compSet.children?.map((entry) => entry.child.name).join(', ') ?? '',
    },
    { key: 'auditBean.created', label: 'Created', type: 'datetime', readOnly: true },
    { key: 'auditBean.timestamp', label: 'Last Modified', type: 'datetime', readOnly: true },
  ],
});
